export const removeDuplicates = (myArr, prop) => {
  return myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
};

export const getUnreadMessage = (ticketsList, helpTS) => {
  return ticketsList.filter(ticket => {
    return ticket["updated_at"] > helpTS && ticket.status !== "closed";
  }).length;
};



// WEBPACK FOOTER //
// ./src/helpers/index.js